import { useQuery } from '@tanstack/react-query';

import BackendService from '../services/backendService';

export const gameActivityResultsQueryKey = (gameId: string) =>
  ['game-results', gameId] as const;

function useGameActivityResults(gameId: string) {
  const { data, isFetching } = useQuery({
    queryKey: gameActivityResultsQueryKey(gameId),
    queryFn: _ => BackendService.instance.game.retrieveResults(gameId),
    staleTime: 1000 * 60 * 60,
  });

  return {
    data,
    isLoading: isFetching,
  };
}

export default useGameActivityResults;
